'use client';

/**
 * Fires a Content Visibl event for Google Analytics. *Note: Do not ever push PII into the data layer!!*
 *
 * @example
 * const { fireEvent } = useContentVisibleEvent();
 * fireEvent({
 *    contentName = '',
      contentDescription = '',
      contentType = '',
      contentLocation = ''
 * });
 * @param {Object} values - values to use for the event
 * @param {string} values.contentName - information about a Equipment details like assetname, assetId, product family name ,modal ,seial number,ect..., non PII field inputs
 * @param {string} values.contentDescription - information about a service recommendation details like title ,description, ect.. , non PII field inputs
 * @param {string} values.contentType -  if the information is type of error, notification, content, infographic, social post, image, review 
 * @param {string} values.contentLocation - content location on the page (where on the page not which page, only in cases there are multiple instances of the form on a page).like modal, body, header, footer
 */

import { useCallback } from 'react';
import { sendGTMEvent } from '@next/third-parties/google';
import { CONTENT_VISIBLE_EVENT } from 'constants/analyticsConstants';

export type ContentVisibleEventType = {
  contentName: string;
  contentDescription: string;
  contentType: string;
  contentLocation: string;
};

export const useContentVisibleEvent = () => {
  const buildEvent = useCallback(
    ({
      contentName = '',
      contentDescription = '',
      contentType = '',
      contentLocation = ''
    }) => ({
      event: CONTENT_VISIBLE_EVENT,
      contentName,
      contentDescription,
      contentType,
      contentLocation
    }),
    []
  );
  const fireContentVisibleEvent = useCallback(
    (values: ContentVisibleEventType) => {
      const event = buildEvent(values);
      sendGTMEvent(event);
    },
    [buildEvent]
  );
  return { fireContentVisibleEvent };
};
